import React from 'react';

const Check = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="20"
    viewBox="0 0 30 29"
  >
    <g id="Group_62" data-name="Group 62" transform="translate(0 0.093)">
      <ellipse
        id="Ellipse_1"
        data-name="Ellipse 1"
        cx="15"
        cy="14.5"
        rx="15"
        ry="14.5"
        transform="translate(0 -0.093)"
        fill="#fff"
      />
      <path
        id="_3325079_check_icon"
        data-name="3325079_check_icon"
        d="M15.94,6,7.731,13.922,4,10.321"
        transform="translate(6.388 4.762)"
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </g>
  </svg>
);

export default Check;
